import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from './Banner';

const asArray = (v) => (Array.isArray(v) ? v : []);

const ModuloTemplate = ({ moduleKey, bnrimg, productImg }) => {
    const { t } = useTranslation();
    const KEY = `pages.modulo.${moduleKey}`;

    // Carga custom.js (Stellar) para activar el parallax del banner, igual que el
    // resto de páginas.
    useEffect(() => {
        const script = document.createElement('script');
        script.src = './assets/js/custom.js';
        script.async = true;
        document.body.appendChild(script);
        return () => { try { document.body.removeChild(script); } catch (e) { /* ya removido */ } };
    }, []);

    const pains = asArray(t(`${KEY}.pains`, { returnObjects: true }));
    const benefits = asArray(t(`${KEY}.benefits`, { returnObjects: true }));

    return (
        <>
            <Header />
            <div className="page-content">
                <Banner
                    title={t(`${KEY}.banner.title`)}
                    pagename={t(`${KEY}.banner.pagename`)}
                    description={t(`${KEY}.banner.description`)}
                    bgimage={bnrimg}
                />

                {/* Intro — captura del módulo + texto */}
                <div className="svc-section svc-cream mobile-page-padding">
                    <div className="container">
                        <div className="svc-intro-grid">
                            {productImg && (
                                <div className="svc-media">
                                    <img src={productImg} alt={t(`${KEY}.banner.title`)} />
                                </div>
                            )}
                            <div className="svc-intro-content">
                                <p className="svc-eyebrow">{t(`${KEY}.banner.pagename`)}</p>
                                <h2 className="svc-title">{t(`${KEY}.persona.headline`)}</h2>
                                <div className="svc-rule" />
                                <p className="svc-text">{t(`${KEY}.persona.body`)}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* El problema */}
                {pains.length > 0 && (
                    <div className="svc-section svc-white mobile-page-padding">
                        <div className="container">
                            <div className="svc-head-center">
                                <h2 className="svc-title">{t(`${KEY}.painsTitle`)}</h2>
                                <div className="svc-rule" />
                            </div>
                            <div className="svc-cards-3">
                                {pains.map((p, i) => (
                                    <div className="svc-card" key={i}>
                                        <h4>{p.title}</h4>
                                        <p style={{ marginBottom: 0 }}>{p.body}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* Qué hace el módulo */}
                {benefits.length > 0 && (
                    <div className="svc-section svc-cream mobile-page-padding">
                        <div className="container">
                            <div className="svc-head-center">
                                <h2 className="svc-title">{t(`${KEY}.benefitsTitle`)}</h2>
                                <div className="svc-rule" />
                            </div>
                            <div className="svc-cta-grid">
                                {benefits.map((b, i) => (
                                    <div className="svc-card" key={i}>
                                        <h4>{b.title}</h4>
                                        <p style={{ marginBottom: 0 }}>{b.body}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* CTA */}
                <div className="svc-section svc-white mobile-page-padding">
                    <div className="container">
                        <div className="svc-head-center">
                            <h2 className="svc-title">{t(`${KEY}.cta.title`)}</h2>
                            <div className="svc-rule" />
                            <p className="svc-text">{t(`${KEY}.cta.body`)}</p>
                        </div>
                        <div className="dp-actions dp-actions-center">
                            <NavLink to="/pricing" className="dp-btn">
                                {t('common.cta.viewPricing')}
                                <span className="arw">&rarr;</span>
                            </NavLink>
                            <NavLink to={t(`${KEY}.cta.shortTo`)} className="dp-btn">
                                {t(`${KEY}.cta.shortLink`)}
                                <span className="arw">&rarr;</span>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ModuloTemplate;
